<template>
  <div class="row">
    <div class="col-sm-9">
      <label>Especialidade</label>
      <select class="form-select" v-model="selecionar">
        <option v-for="item in especialidade" :key="item.id" :value="item">
          {{ item.nome }}
        </option>
      </select>
    </div>
    <div class="col justify-content-end" style="margin-top: 20px">
      <div class="col">
        <div class="float-end">
          <div class="row">
            <div class="col">
              <button type="button" class="btn btn-primary" @click="selecionarItem" style="margin-right: 10px">Selecionar</button>
            </div>
            <div class="col">
              <button v-if="itensSelecionados.length > 0" type="button" class="btn btn-primary" @click="salvarItens" style="margin-right: 10px">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <a-table :dataSource="itensSelecionados" :columns="columns"> </a-table>
  </div>
</template>

<script>
import { domainEspecialidade } from '@/utils/servicos-utils';
import { createEspecialidade, getEspecialidades } from '@/components/service/especilidadeService';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'FormEspecialidade',

  data() {
    return {
      especialidade: [],
      itensSelecionados: [],
      selecionar: null,
      columns: [
        {
          title: 'Especialidade',
          dataIndex: 'nome',
          key: 'nome',
        },
      ],
    };
  },
  async created() {
    await this.getEspecialidades();
  },
  methods: {
    async getEspecialidades() {
      await domainEspecialidade().then((r) => (this.especialidade = r.data));
    },

    selecionarItem() {
      if (this.selecionar !== null) {
        this.itensSelecionados = [];
        this.itensSelecionados.push(this.selecionar);
        this.selecionar = null;
      }
    },

    async salvarItens() {
      await getEspecialidades().then(async (esp) => {
        let filter = esp.data.filter((e) => e.especialidade.id === this.itensSelecionados[0].id);
        if (filter.length === 0) {
          await createEspecialidade(this.montarObjetoEspecialidade(this.itensSelecionados[0]))
            .then(() => {
              openNotification(typesNotification.success, 'Salvo com Sucesso.');
              this.itensSelecionados = [];
            })
            .catch((er) => console.log(er));
        } else {
          this.itensSelecionados = [];
          openNotification(typesNotification.warning, 'Especialidade ja salva na base de dados');
        }
      });
    },
    montarObjetoEspecialidade(especialidade) {
      return {
        especialidade: especialidade,
      };
    },
  },
};
</script>

<style scoped></style>
